import { Logger } from "../utils/logger";

export type ConsentEventType = "init" | "changed";

/**
 * 🔹 Wartet, bis ein CMP verfügbar ist (__cmp, Cookiebot, ConsentManagerAPI, OneTrust)
 */
export function waitForConsentManager(callback: () => void): void {
    if (
        typeof window.__cmp === "function" ||
        typeof window.ConsentManagerAPI?.show === "function" ||
        typeof window.Cookiebot !== "undefined" ||
        typeof window.OneTrust !== "undefined"
    ) {
        Logger.info("✅ ConsentManager sofort verfügbar.");
        callback();
        return;
    }

    let resolved = false;

    const checkAvailable = () => {
        if (
            (typeof window.__cmp === "function" ||
                typeof window.ConsentManagerAPI?.show === "function" ||
                typeof window.Cookiebot !== "undefined" ||
                typeof window.OneTrust !== "undefined") &&
            !resolved
        ) {
            resolved = true;
            Logger.info("✅ ConsentManager nachgeladen und erkannt.");
            callback();
        }
    };

    const interval = setInterval(checkAvailable, 500);
    const observer = new MutationObserver(() => checkAvailable());

    observer.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(() => {
        clearInterval(interval);
        observer.disconnect();
        if (!resolved) {
            Logger.error("❌ Timeout: ConsentManager wurde nach 20s nicht gefunden.");
        }
    }, 20000);
}

/**
 * 🔹 CMP-unabhängiger Consent-Check – basiert auf Cookie `trustleap_video=1`
 */
export async function hasVideoConsentAsync(): Promise<boolean> {
    try {
        const consent = document.cookie.includes("trustleap_video=1");
        Logger.info("🍪 trustleap_video Cookie erkannt:", consent);
        return consent;
    } catch (err) {
        Logger.error("❌ Fehler beim Lesen des trustleap_video-Cookies:", err);
        return false;
    }
}

/**
 * 🔹 Reagiert auf Consent-Änderung – prüft periodisch auf Cookie `trustleap_video=1`
 */
export function onConsentChange(callback: () => void): void {
    let handled = false;

    const checkConsent = () => {
        const consent = document.cookie.includes("trustleap_video=1");

        if (consent && !handled) {
            handled = true;
            callback();
        }

        if (handled) clearInterval(interval);
    };

    const interval = setInterval(checkConsent, 1000);
    setTimeout(() => clearInterval(interval), 30000);
}

/**
 * 🔹 Öffnet das Consent-Tool (unterstützt Cookiebot, OneTrust, ConsentManager.de)
 */
export function openConsentTool(): void {
    Logger.info("🎯 Öffne Consent Tool...");

    try {
        const domTrigger = document.querySelector('[data-role="open-consent-layer"]') as HTMLElement;

        if (domTrigger) {
            Logger.info("🟢 DOM-Trigger gefunden → wird geklickt");
            domTrigger.click();
            return;
        }

        if (typeof window.__cmp === "function") {
            window.__cmp('showConsentTool', null, () => { });
        } else if (window.Cookiebot?.show) {
            window.Cookiebot.show();
        } else if (window.OneTrust?.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
        } else if (window.ConsentManagerAPI?.show) {
            window.ConsentManagerAPI.show();
        } else if (window.cmpmngr?.api?.__cmp) {
            window.cmpmngr.api.__cmp('showConsentTool', null, () => { });
        } else {
            Logger.warn("❌ Kein Consent-Trigger gefunden");
            alert("Consent-Tool konnte nicht geöffnet werden.");
        }
    } catch (err) {
        Logger.error("❌ Fehler beim Öffnen des Consent-Tools", err);
    }
}
